import { IFilter } from '@epicuro-next/ataraxia/models';
import { FiltersFieldIds } from '@epicuro-next/models/order-book';
import { createReducer, on } from '@ngrx/store';
import { OrderFilter } from 'graphql-api/baskets-api-interfaces';

import {
  clearFilterById,
  loadFilters,
  loadFiltersFailure,
  loadFiltersSuccess,
  resetFiltersState,
  setActiveFilters,
  setInitialSelectedFiltersFromUrlSuccess,
  setSearchQuery,
  toggleFilter,
} from '../actions/filters.actions';
import { isIncomingFilter } from '../shared/is-incoming-filter/is-incoming-filter';
import { mapFiltersToUi } from '../shared/map-filters-to-ui/map-filters-to-ui';

export const filtersFeatureKey = 'filters';

export interface FiltersState {
  filters: OrderFilter[];
  activeFilters: IFilter[];
  search: string;
  isLoading: boolean;
  loaded: boolean;
  error: string | null;
  lastActivatedFilterId: string | null;
}

export const initialState: FiltersState = {
  filters: [],
  activeFilters: [],
  search: '',
  isLoading: false,
  loaded: false,
  error: null,
  lastActivatedFilterId: null,
};

export const reducer = createReducer<FiltersState>(
  initialState,
  on(
    loadFilters,
    (state): FiltersState => ({
      ...state,
      isLoading: true,
    }),
  ),
  on(loadFiltersSuccess, (state, { total, filters }) => {
    const availableFilters = mapFiltersToUi(filters);
    return {
      ...state,
      filters: availableFilters,
      total,
      page: 0,
      isLoading: false,
      loaded: true,
      hasMorePages: true,
    };
  }),
  on(loadFiltersFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error,
  })),

  on(setActiveFilters, (state, { filters }) => ({
    ...state,
    activeFilters: filters,
  })),

  on(toggleFilter, (state, { filter }) => {
    return {
      ...state,
      lastActivatedFilterId: filter.fieldId,
    };
  }),
  on(clearFilterById, (state, { fieldId }) => {
    const filteredActiveFilters =
      fieldId !== FiltersFieldIds.DeliveryYear
        ? state.activeFilters.filter((filter) => filter.fieldId !== fieldId)
        : // Do not clean order status when year changed
          // will be refactored in scope of implementing dynamic filters
          state.activeFilters.filter(isIncomingFilter);
    return {
      ...state,
      activeFilters: filteredActiveFilters,
      lastActivatedFilterId: fieldId,
    };
  }),
  on(
    setSearchQuery,
    (state, { search }): FiltersState => ({
      ...state,
      search,
      lastActivatedFilterId: null,
    }),
  ),
  on(
    setInitialSelectedFiltersFromUrlSuccess,
    (state, { search, filters }): FiltersState => {
      return {
        ...state,
        search,
        activeFilters: filters,
      };
    },
  ),
  on(resetFiltersState, () => ({ ...initialState })),
);
